module.exports = __webpack_public_path__ + "img/ESBE_1569.184e2597.png";